import React, { useState, useEffect } from "react";
import {
	Card,
	CardBody,
	CardHeader,
} from "../../../../_metronic/_partials/controls";
import {
	Button,
	TextField,
	MuiThemeProvider,
	createMuiTheme,
	FormControlLabel,
	Checkbox,
} from "@material-ui/core";
import { useHistory, useParams } from "react-router-dom";
import {
	deleteGpsDevice,
	getGpsDeviceById,
	postGpsDevice,
	updateGpsDevice,
} from "../../../../api/gpsdevice";
import { useSkeleton } from "../../../hooks/useSkeleton";
import { alertError, alertInfo, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import PreviewDialog from '../../../components/dialogs/PreviewDialog';
import { SERVER_URL } from '../../../../utils';

// Create theme for delete button (red)
const theme = createMuiTheme({
	palette: {
		secondary: {
			main: "#F64E60",
		},
	},
});

function getEmptyGpsDevice() {
	return {
		code: "",
		phone: "",
		active: true,
	};
}

export default function EditGpsDevicesPage() {
	const [gpsDevice, setGpsDevice] = useState(getEmptyGpsDevice());
	const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
	const gpsDeviceId = useParams().id;
	const history = useHistory();

	const {
		isLoading: isLoadingData,
		disableLoading: disableLoadingData,
		ContentSkeleton,
	} = useSkeleton();

	useEffect(() => {
		if (!gpsDeviceId) {
			disableLoadingData();
			return;
		}
		getGpsDeviceById(gpsDeviceId)
			.then((res) => {
				if (res.status === 200) {
					setGpsDevice(res.data);
					disableLoadingData();
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: "Could not get gpsDevice.",
				});
				history.push("/gpsDevices");
			});
	}, [gpsDeviceId, disableLoadingData, history]);

	function saveGpsDevice() {
		if (!gpsDeviceId) {
			postGpsDevice(gpsDevice)
				.then((res) => {
					if (res.status === 201) {
						alertSuccess({
							title: "Saved!",
							customMessage: "GpsDevice successfully created."
						});
						history.push("/gpsDevices");
					}
				})
				.catch((error) => {
					alertError({
						error: error,
						customMessage: "Could not save gpsDevice.",
					});
				});
		} else {
			updateGpsDevice(gpsDeviceId, gpsDevice)
				.then((res) => {
					if (res.status === 200) {
						alertSuccess({
							title: "Saved!",
							customMessage: "Changes successfully saved.",
						});
						history.push("/gpsDevices");
					}
				})
				.catch((error) => {
					alertError({
						error: error,
						customMessage: "Could not save changes.",
					});
				});
		}
	}

	const handleChange = (element) => (event) => {
		setGpsDevice({ ...gpsDevice, [element]: event.target.value });
	};

	if (isLoadingData) return <ContentSkeleton />;
	else
		return (
			<>
				<Card>
					<CardHeader title="Edit gpsDevice"></CardHeader>
					<CardBody>
						<TextField
							id={`reference`}
							label="Reference"
							value={gpsDevice.reference}
							onChange={handleChange("reference")}
							InputLabelProps={{
								shrink: true,
							}}
							margin="normal"
							variant="outlined"
							required
						/>
						<TextField
							id={`code`}
							label="Code"
							value={gpsDevice.code}
							onChange={handleChange("code")}
							InputLabelProps={{
								shrink: true,
							}}
							margin="normal"
							variant="outlined"
							required
						/>
						<TextField
							id={`phone`}
							label="Phone number"
							value={gpsDevice.phone}
							onChange={handleChange("phone")}
							InputLabelProps={{
								shrink: true,
							}}
							margin="normal"
							variant="outlined"
							required
						/>
						
						<br />
						<br />
						<FormControlLabel
							control={
								<Checkbox
									checked={gpsDevice.active}
									onChange={() =>
										setGpsDevice({
											...gpsDevice,
											active: !gpsDevice.active,
										})
									}
									name="checkActive"
								/>
							}
							label="Active"
						/>
					</CardBody>
				</Card>
				<Button
					onClick={() => history.push("/gpsDevices")}
					variant="outlined"
					style={{ marginRight: "20px" }}
				>
					Back
				</Button>
				<Button
					onClick={() => saveGpsDevice()}
					variant="outlined"
					color="primary"
					style={{ marginRight: "20px" }}
				>
					Save gpsDevice
				</Button>
				{gpsDeviceId && (
					<>
						<MuiThemeProvider theme={theme}>
							<Button
								onClick={() => setOpenConfirmDialog(true)}
								variant="outlined"
								color="secondary"
							>
								Delete gpsDevice
							</Button>
						</MuiThemeProvider>

						<ConfirmDialog
							title={"Are you sure you want to delete this gpsDevice?"}
							open={openConfirmDialog}
							setOpen={setOpenConfirmDialog}
							onConfirm={() => {
								deleteGpsDevice(gpsDeviceId)
									.then((res) => {
										if (res.status === 204) {
											alertSuccess({
												title: "Deleted!",
												customMessage:
													"GpsDevice deleted successfully",
											});
											history.push("/gpsDevices");
										}
									})
									.catch((error) => {
										alertError({
											error: error,
											customMessage:
												"Could not delete economic sector.",
										});
									});
							}}
						/>
					</>
				)}
			</>
		);
}
